var _module_exports = "<div>[modal-content]</div>";;
var path = '/app/components/common/modal/modal_v2.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;